import React from "react";
import * as PropTypes from "prop-types";
import {imageCdnUrls} from "../common/ImageCdnUrls";
import {NavigationInfo} from "../../models/topBarModel";

export default function BackNav(props) {
    const {navigationInfo, onNavigate} = props;

    return <>
        {navigationInfo &&
            <div className="top-rail-breadcrumbs">
                <span onClick={onNavigate} className="navigation">
                    <img className="back-arrow" src={imageCdnUrls.backArrow} />
                    {navigationInfo.display}
                </span>
            </div>
        }
    </>;
}

BackNav.propTypes = {
    navigationInfo: PropTypes.shape(NavigationInfo),
    onNavigate: PropTypes.func
};
